import { apiRequest, CompletedApiRequest } from '../../core/api/_tools';
import { UserSummary } from 'common/dist/types/users';

export function fetchUserSummaryById(
  userId: string
): CompletedApiRequest<UserSummary> {
  return apiRequest(`/api/users/summary/id/${userId}`);
}
